import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://puwkrtqzszjsjkxowvin.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB1d2tydHF6c3pqc2preG93dmluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQwOTAyODIsImV4cCI6MjA2OTY2NjI4Mn0.fwAQ1FmbzQBnAmieAdM95-HA21iIm3jWVIcP58zMJxw";

// Create an untyped client to work around the type issues
export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
}) as any;